import AdminLiveRiderMapPage from '../../../components/admin/riders/AdminLiveRiderMapPage'

export default function RiderTracking() {
  return <AdminLiveRiderMapPage />
}
